import { useState } from 'react';

import Dialog from '../Dialog';

const AnchorDialog = ({ children, anchorContent, ...rest }: any) => {
  const [isVisible, setIsVisible] = useState<boolean>(false);

  const open = (): void => setIsVisible(true);
  const close = (): void => setIsVisible(false);
  return (
    children && (
      <>
        {anchorContent(open, close)}
        <Dialog open={isVisible} onClose={close} {...rest}>
          {typeof children === 'function' ? children(open, close) : children}
        </Dialog>
      </>
    )
  );
};

export default AnchorDialog;
